module.exports = vendor_03c7176176808e6d7438;